import { useTranslation } from 'react-i18next'
import { useAPI } from 'global'
import { useMe } from 'contexts'
import { camelize } from 'utils'
import { Button, confirm } from 'components'
import { toast } from 'react-toastify'

export default function UserCell(props) {
  const { t } = useTranslation(null, { useSuspense: false })
  const api = useAPI()
  const { me } = useMe()
  const { data: user, onUpdate } = props

  const deactivateUser = () => confirm(() => {
    api.deactivateUser(user.id).then(onUpdate).catch(() => toast.error(t('error.userDeactivate')))
  }, t('user.confirmDeactivate', { userFirstName: `${user?.firstName}`, userLastName: `${user?.lastName}` }), t('user.confirmDeactivateDescription'))

  const activateUser = () => api.activateUser(user.id).then(onUpdate).catch(() => toast.error(t('error.userActivate')))

  const unlockUser = () => confirm(() => {
    api.unlockUser(user.id).then(() => {
      toast.success(t('success.request'))
      onUpdate()
    }).catch(() => toast.error(t('error.request')))
  }, t('user.confirmUnlock', { userFirstName: `${user?.firstName}`, userLastName: `${user?.lastName}` }), t('user.confirmUnlockDescription'))

  return (
    <div className='user-cell-comp'>
      <div className='info-container'>
        <p className="name">{`${user?.firstName} ${user?.lastName}`}</p>
        <div className='row'>
          <p className="subtitle">{t(`roles.${camelize(user?.roleKey)}`)}</p>
          {user?.externallyAuthenticated && <i title={t('user.externallyAuthenticated')} className='material-icons external-auth-icon'>{'cloud_done'}</i>}
        </div>
        <p className="subtitle">{user?.employeeIdentifier}</p>
      </div>
      {user?.id !== me?.id && me?.canEditUser &&
        <>
          {user.lockedOut && <Button flat icon="lock_open" onClick={unlockUser} />}
          {user?.status !== 'inactive' ?  <Button id="delete-btn" flat danger icon="delete" onClick={deactivateUser}/> : <Button icon="person_add" flat highlight onClick={activateUser}/>}
        </>
      }
    </div>
  )
}
